import TextField from 'components/forms/textField/TextField';
import PropertyFormFieldLabel from 'pages/property/common/PropertyFormFieldLabel';
import { useTranslation } from 'react-i18next';

const BedroomsField = () => {
  const { t } = useTranslation();

  return (
    <TextField
      label={
        <PropertyFormFieldLabel name="capacityDetails.bedroomCount">
          {t('pageProperty.mainSettings.capacityDetails.bedroomCount')}
        </PropertyFormFieldLabel>
      }
      name="capacityDetails.bedroomCount"
      colSmInput={7}
      colSmLabel={5}
      rightTooltip={t(
        'pageProperty.mainSettings.capacityDetails.bedroomCountTooltip',
      )}
      disabled
    />
  );
};

export default BedroomsField;
